import { h as u } from "./chunks/index-Dj1VNACs.mjs";
function y(r) {
  const e = (n, l) => {
    var d;
    const { renderElement: i, models: f, layout: c } = l, m = c[n], o = f[n];
    if (o || u.handleError(`Could not find model with id: ${n}`), o.hidden)
      return null;
    const a = ((d = m.children) == null ? void 0 : d.map((h) => e(h, l))) || [], t = i({ children: a, key: n, model: o });
    return typeof t > "u" && u.handleError(`Could not find component to render for model: ${JSON.stringify(o)}`), t === null ? null : t;
  };
  return e("root", r);
}
function p(r, e) {
  return r.model.type === e;
}
export {
  y as LayoutFactory,
  p as hasModelType
};
//# sourceMappingURL=LayoutFactory.mjs.map
